var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 40,
    viewBox: "0 0 105 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06445 36.3387H6.2981V15.2654H1.06445V36.3387Z",
    fill: "#112D35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68138 2C1.64843 2 0.000488281 3.64827 0.000488281 5.68122C0.000488281 7.71416 1.64843 9.3621 3.68138 9.3621C5.71432 9.3621 7.36226 7.71416 7.36226 5.68122C7.36226 3.64827 5.71432 2 3.68138 2",
    fill: "#112D35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8871 14.8252C17.9558 14.8252 13.1304 19.6506 13.1304 25.582V36.3387H18.364V25.582C18.364 22.5366 20.8418 20.0588 23.8871 20.0588C26.9325 20.0588 29.4103 22.5366 29.4103 25.582V36.3387H34.6439V25.582C34.6439 19.6506 29.8185 14.8252 23.8871 14.8252",
    fill: "#112D35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7761 8.2832H53.5425V26.6994C53.5425 32.0145 57.8665 36.3388 63.1815 36.3388H67.3907V31.1052H63.1815C60.7525 31.1052 58.7761 29.1288 58.7761 26.6994V20.4992H65.7552V15.2655H58.7761V8.2832Z",
    fill: "#112D35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4522 31.1133C81.4942 32.1976 78.2051 30.673 77.1208 27.7147C76.0365 24.7563 77.5611 21.4676 80.5194 20.3833C83.4777 19.299 86.7667 20.8233 87.8511 23.7819C88.9354 26.7402 87.4105 30.0289 84.4522 31.1133M104.582 17.649C103.882 15.7394 101.767 14.7588 99.8574 15.4591C98.8205 15.8389 98.0609 16.638 97.692 17.5931L97.69 17.5879C97.0096 19.3477 94.1949 21.8706 90.1866 17.9251L90.1882 17.93C87.2561 15.0502 82.8166 13.9354 78.7079 15.4414C73.0248 17.5247 70.0959 23.8427 72.1789 29.5258C74.2619 35.2092 80.5802 38.1381 86.2636 36.0551C90.3721 34.5491 93.0396 30.8297 93.4164 26.7369L93.4184 26.7418C93.9273 21.1405 97.7057 21.2468 99.3625 22.15L99.3605 22.1451C100.259 22.6357 101.355 22.7541 102.392 22.3744C104.302 21.6744 105.282 19.5587 104.582 17.649",
    fill: "#112D35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4761 36.3387H46.7097V15.2654H41.4761V36.3387Z",
    fill: "#112D35"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.093 2C42.0601 2 40.4121 3.64827 40.4121 5.68122C40.4121 7.71416 42.0601 9.3621 44.093 9.3621C46.1259 9.3621 47.7739 7.71416 47.7739 5.68122C47.7739 3.64827 46.1259 2 44.093 2",
    fill: "#112D35"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5837e072a85e3bc72dd6439053fa2a21.svg";
export { ForwardRef as ReactComponent };